// Import component scripts (auto-generated)
import './components.js';

// Import layout scripts (auto-generated)
import './layouts.js';

// Import theme scripts
import './core.js';
import './faq.js';
import './lazy-load-images.js';
import './scroll-indicator.js';
import './anchor-scrolling.js';
